import { Colors } from '@oy/uicore';
import { useEffect, useRef, useState } from 'react';
import { flushSync } from 'react-dom';
import { useEnv, useHasFocus } from 'src/hooks';
import { storage } from 'src/utilities/Storage';
import { useSidebarState } from '../../hooks';

type UseMenuDropdownImplProps = {
  id: string;
};

export const useMenuDropdownImpl = ({ id }: UseMenuDropdownImplProps) => {
  const PREFIX = 'menuDropdown';
  const elementRef = useRef<HTMLDivElement>(null);
  const [isHover, setIsHover] = useState(false);
  const [isSubHover, setIsSubHover] = useState(false);

  const hasFocus = useHasFocus();
  const { isProdEnv } = useEnv();
  const { isSidebarCollapsed } = useSidebarState();

  const [show, setShow] = useState<boolean>(() => {
    return storage.get(PREFIX + id, false);
  });
  const state = { show };
  const onDropdownClick = () => {
    flushSync(() => setShow((prev: boolean) => !prev));
  };

  useEffect(() => {
    storage.set(PREFIX + id, show);
  }, [id, show]);

  useEffect(() => {
    if (hasFocus) setShow(() => storage.get(PREFIX + id, false));
  }, [id, show, hasFocus]);

  const getIconColor = () => {
    if (isProdEnv) {
      if (isHover && !isSubHover) {
        return 'var(--token-color-brand100)';
      }
      return Colors.WHITE;
    }
    return Colors.BLACK100;
  };

  return {
    state,
    elementRef,
    isSidebarCollapsed,
    setIsHover,
    setIsSubHover,
    onDropdownClick,
    getIconColor,
  };
};
